module.exports = __webpack_public_path__ + "static/media/profile_popup_bg.aca4ce55.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/profile_popup_bg.svg
// module id = 325
// module chunks = 0